<app-dropdown-select
  [label]="'accountProduct' | i18n"
  [placeholder]="placeholder() || ('accountProductPlaceholder' | i18n)"
  [panelStyle]="'mat'"
  [detachPanel]="true"
  [options]="institutionAccountNames()"
  [selectedOption]="preselectedInstitutionalAccount()?.name"
  (optionSelected)="institutionAccountSelected($event)"
  [isRequired]="isRequired()"
  [isEnabled]="!disabled()"
  [customShadowClass]="customShadowClass()"
  [showGradientBorder]="showGradientBorder()"
>
</app-dropdown-select>
